interface MenuInterface {
  href: string;
  label: string;
}

export const formatNavigationSchema = (menu: MenuInterface[]) => {
  const names: string[] = [];
  const urls: string[] = [];

  if (Array.isArray(menu)) {
    menu.forEach(item => {
      names.push(item.label);
      if (item?.href) {
        if (item.href.includes('https://') || item.href.includes('//')) {
          urls.push(item.href);
        } else {
          urls.push('https://www.benzinga.com' + item.href);
        }
      }
    });
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'SiteNavigationElement',
    name: names,
    url: urls,
  };
};
